<template>
  <div id="app">
    <v-app>
      <router-view />
      <v-snackbar
        v-model="showProxyBanner"
        :timeout="-1"
        location="bottom center"
        color="warning"
        class="proxy-snackbar"
      >
        <div class="d-flex align-center">
          <i class="fa fa-user-secret me-2"></i>
          <span>
            {{ $t("currentlyViewingAs") }}
            {{
              (userDetails.employeeFullName && userDetails.userDefinedEmployeeId
                ? userDetails.employeeFullName +
                  " - " +
                  userDetails.userDefinedEmployeeId
                : "a proxy user") + " "
            }}
            {{ $t("impersonatedSession") }}
          </span>
        </div>
        <template #action>
          <v-btn text :loading="exitingProxy" @click="exitProxyMode">
            <i class="fa fa-sign-out-alt mt-1 mr-1"></i>
            {{ $t("exitProxy") }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-app>
  </div>
</template>
<script>
import { CUSTOM_COLOR_PICKER } from "@/graphql/commonQueries.js";
export default {
  data: () => ({
    exitingProxy: false,
  }),
  computed: {
    showProxyBanner() {
      return this.$store.state.isProxyUser;
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    // Add storage event listener to sync proxy state across tabs
    // The storage event fires in OTHER tabs when localStorage is modified
    window.addEventListener("storage", this.handleStorageChange);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    this.$store.dispatch("fetchUserIp");
    this.retriveCustomColorPicker();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("storage", this.handleStorageChange);
  },
  methods: {
    async exitProxyMode() {
      this.exitingProxy = true;
      try {
        await this.$store.dispatch("impersonateUser", { exitProxy: true });
      } catch (err) {
        this.$store.dispatch("handleApiErrors", {
          error: err,
          action: "exiting",
          form: "proxy mode",
          isListError: false,
        });
      } finally {
        this.exitingProxy = false;
      }
    },
    retriveCustomColorPicker() {
      if (!localStorage.getItem("brand_color")) {
        let vm = this;
        vm.isErrorInList = false;
        vm.$apollo
          .query({
            query: CUSTOM_COLOR_PICKER,
            client: "apolloClientAC",
            fetchPolicy: "no-cache",
          })
          .then((response) => {
            if (
              response.data &&
              response.data.customColorPicker &&
              response.data.customColorPicker.colorResult &&
              !response.data.customColorPicker.errorCode.length
            ) {
              let colour = response.data.customColorPicker.colorResult[0];
              localStorage.setItem("brand_color", JSON.stringify(colour));
            } else {
              vm.handleListError();
            }
          })
          .catch((err) => {
            vm.handleListError(err);
          });
      }
    },
    /**
     * Handle storage change to sync proxy state across tabs.
     * When the proxy state changes in another tab (via localStorage),
     * this tab receives the storage event and reloads to sync state.
     */
    handleStorageChange(event) {
      // Only react to proxy state changes
      if (event.key === "proxyStateChanged") {
        // Reload the page to sync all state (sidebar, permissions, user details, etc.)
        window.location.reload();
      }
    },
    handleListError(err = "") {
      this.jobPostMemberLoading = false;
      this.$store
        .dispatch("handleApiErrors", {
          error: err,
          action: "retrieving",
          form: "custom color picker",
          isListError: true,
        })
        .then((errorMessages) => {
          this.errorContent = errorMessages;
          this.isErrorInList = true;
        });
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  z-index: 30;
  width: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  box-shadow: none;
  border: 0;
}
::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: none;
  border: 0;
}

::-webkit-scrollbar-track {
  background-color: #eaeaea;
}
</style>
<style scoped>
.proxy-snackbar :deep(.v-snack__wrapper) {
  width: 50% !important;
  max-width: 50% !important;
  margin: 0 auto !important;
}
</style>
